import { UserReduxState } from '../../../interfaces/users';

export const getMe = (state: UserReduxState) => state.me;
